<div class="google-places-autocomplete" style="position: relative; z-index: 9999;">
  <input
    #placesInput
    type="text"
    class="form-control"
    [placeholder]="placeholder"
    autocomplete="off"
    style="position: relative; z-index: 9999;"
  />
</div>
